import { TMapOffersResult } from '../../../types/common/offer';
import { IOfferForAnalytic } from '../types';

/** Разметка ждёт psk скаляром, на лендинге это диапазон — отдаём строкой '{from} - {to}'.
    Значения не округляем: в swagger они decimal, то есть string | number. */
const formatPsk = (psk?: { from?: number | string | null; to?: number | string | null } | null): string | null =>
  psk && psk.from != null && psk.to != null ? `${psk.from} - ${psk.to}` : null;

export const getOffersForAnalytic = (offers: TMapOffersResult): IOfferForAnalytic[] =>
  offers.map((offer, place) => {
    if (offer.type === 'multi') {
      return {
        place,
        bank: offer.content[0].title.name,
        psk: null,
        interestRate: null,
        creditAmount: null,
        income: null,
        monthlyPayment: null,
      };
    }

    const { conditions, title } = offer.content;

    return {
      place,
      bank: title.name,
      psk: formatPsk(conditions.psk),
      interestRate: conditions.rate?.rate ?? null,
      creditAmount: conditions.limit ?? null,
      income: conditions.income ?? null,
      monthlyPayment: conditions.monthlyPayment ?? null,
    };
  });
